import type { ComponentProps } from "react";
import { cn } from "@/shared/utils/cn";

export function FormActions({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn("flex w-full shrink-0 flex-wrap justify-end gap-2.5 [&>button]:min-h-12 [&>button]:flex-1 [&>a]:min-h-12 [&>a]:flex-1 sm:[&>button]:min-w-[150px] sm:[&>button]:flex-none sm:[&>a]:min-w-[150px] sm:[&>a]:flex-none", className)}
      {...props}
    />
  );
}
